// src/utils/segnalazioniCliente.js
// ═══════════════════════════════════════════════════════════════════════════
// SEGNALAZIONI CLIENTE: cliente, commessa e ciclo (ottobre 2026, W409)
// ═══════════════════════════════════════════════════════════════════════════
// • La segnalazione dice SEMPRE di chi è e su quale commessa: scelto il cliente si vedono
//   le sue commesse; scelta la commessa, il cliente si compila da solo. Se il cliente ha
//   commesse, o se ne sceglie una o si dice esplicitamente «non riguarda una commessa».
// • Ciclo a pulsanti, non più una tendina libera:
//     Nuova ──✋ Prendi in carico──▶ In lavorazione ──✅ Chiudi (esito obbligatorio)──▶ Chiusa
//     Chiusa ──↩️ Riapri (motivo obbligatorio)──▶ In lavorazione
//   Chi l'ha registrata riceve un avviso a ogni passaggio fatto da altri.
// Funzioni pure: prove in demo/prove/prova_segnalazioni.mjs.
// ═══════════════════════════════════════════════════════════════════════════

const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]/g, "");

/** Nome del cliente di una commessa: il suo campo, o la cartella cliente (commessa padre). */
export function clienteDellaCommessa(commessa, progettiPerId = {}) {
  if (!commessa) return { clienteId: "", clienteNome: "" };
  const padre = commessa.parentId ? progettiPerId[commessa.parentId] : null;
  return { clienteId: commessa.clienteId || padre?.clienteId || "", clienteNome: commessa.clienteNome || padre?.clienteNome || padre?.name || "" };
}

/** Le commesse di un cliente (per id; se manca, per nome uguale), le aperte prima. */
export function commesseDelCliente(commesse, { clienteId, clienteNome } = {}, progettiPerId = {}) {
  if (!clienteId && !norm(clienteNome)) return [];
  return (commesse || []).filter(c => {
    const cl = clienteDellaCommessa(c, progettiPerId);
    return (clienteId && cl.clienteId === clienteId) || (norm(clienteNome) && norm(cl.clienteNome) === norm(clienteNome));
  }).sort((a, b) => ((a.statoCommessa === "chiusa") - (b.statoCommessa === "chiusa")) || String(b.codiceCommessa || "").localeCompare(String(a.codiceCommessa || "")));
}

/** «[AI-26-031] Impianto fotovoltaico…» */
export const etichettaCommessa = (s) => (s?.projectName || s?.name ? `${s.codiceCommessa ? `[${s.codiceCommessa}] ` : ""}${s.projectName || s.name}` : "");

/** Cosa può fare questa persona su questa segnalazione, adesso. */
export function azioniSegnalazione(seg, uid, { canAdmin = false } = {}) {
  if (!seg?.id || !uid) return { prendi: false, chiudi: false, riapri: false };
  const compilatore = seg.compilatoreUid === uid;
  const assegnatario = seg.assegnatarioUid === uid;
  const inCarico = seg.presaInCaricoUid === uid;
  const chiusa = seg.stato === "chiusa";
  return {
    // senza assegnatario la può prendere chi l'ha registrata o un amministratore (e diventa sua)
    prendi: !chiusa && !seg.presaInCaricoData && (assegnatario || (!seg.assegnatarioUid && compilatore) || canAdmin),
    chiudi: !chiusa && (inCarico || assegnatario || compilatore || canAdmin),
    riapri: chiusa && (compilatore || assegnatario || inCarico || canAdmin),
  };
}

export const MIN_ESITO = 5;
/** Esito e motivo: obbligatori e non di una parola sola. */
export const testoValido = (t) => String(t || "").trim().length >= MIN_ESITO;

/** A chi avvisare di un passaggio: chi l'ha registrata e chi la segue, mai chi ha fatto l'azione. */
export function daAvvisare(seg, uidAutore) {
  return [...new Set([seg?.compilatoreUid, seg?.assegnatarioUid, seg?.presaInCaricoUid].filter(u => u && u !== uidAutore))];
}

/** Giorni dalla registrazione alla chiusura (per il tempo medio di gestione). */
export function giorniGestione(seg) {
  const sec = (t) => (t?.seconds ?? (t?.toDate ? t.toDate().getTime() / 1000 : null));
  const inizio = sec(seg?.createdAt), fine = sec(seg?.chiusaData) ?? sec(seg?.updatedAt);
  return inizio != null && fine != null && fine >= inizio ? (fine - inizio) / 86400 : null;
}
